import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ExtranetUserListItem, UpdateUserInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateUserInput }) =>
      getExtranetApi().patch<UpdateUserInput, ExtranetUserListItem>(`/v1/extranet/users/${id}`, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['extranet', 'users'] });
    },
  });
};
